// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"f1d9ad04","150":"6b96b704","307":"08cc9122","574":"f851ce22","980":"ebe3cf17"}[chunkId] + ".chunk.js";
};